import json from "@/data/copy/product-canvas.json";
import { createCopyGetter } from "@/lib/localize-copy";

export const getProductCanvasCopy = createCopyGetter(json);
